import React from 'react';
import { List } from 'immutable';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import TagListElement from './TagListElement';
import { getTags } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { TagsByBoards } from '../tagUtils';

type Props = {
    handleToggleTagSelection: (tag: Tag) => void;
    handleClickEdit: (tag: Tag) => void;
    handleCreateCopyAndAddToElement: (tag: Tag) => void;
    elements: List<ImMNElement>;
    tagsByBoards: TagsByBoards;
};

const TagLists = (props: Props) => {
    const { handleToggleTagSelection, handleClickEdit, elements, tagsByBoards } = props;

    const elementTagIds = elements.flatMap((element) => getTags(element) || []);

    return (
        <div className="TagLists">
            {tagsByBoards.map(({ title, tags }, index) => {
                return (
                    <div key={index} className="mb-3">
                        {title && <p className="w-full text-left mb-1">{title}</p>}
                        {tags.map((tag) => {
                            return (
                                <TagListElement
                                    key={tag.id}
                                    tag={tag}
                                    isSelected={elementTagIds?.includes(tag.id)}
                                    handleClickTag={handleToggleTagSelection}
                                    handleClickEdit={handleClickEdit}
                                    size="sm"
                                />
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};

export default TagLists;
